import { SVGProps } from 'react';

export default function X(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"  {...props}>
      <path d="M27.097 11.8125H30.317L23.247 19.61L31.507 30.1875H25.025L19.95 23.7596L14.14 30.1875H10.92L18.41 21.8476L10.5 11.8125H17.143L21.728 17.6844L27.097 11.8125ZM25.97 28.3568H27.755L16.205 13.5754H14.287L25.97 28.3568Z" className='fill-[#FF00FE] dark:fill-white' />
    </svg>
  )
}